/* istanbul ignore file */

export default {
  "privacy-policy":
    "https://www.vodafone.es/c/conocenos/es/vodafone-espana/quienes-somos/legal-y-regulatorio/politica-de-privacidad-y-cookies/",
  "terms-and-conditions": "https://www.vodafone.es/c/conocenos/es/aviso-legal/",
  "help-and-support": "https://ayudacliente.vodafone.es/particulares/temas-de-ayuda/",
  "cookie-preferences": "cookie-preferences",
};
